function init_geography(e, placemarks) {

    //====== MAP =====//

    let clickCallback = function (target) {
        let url = '/ajax/get-redirect-uri-geography-to-contact'
        let city_id = target.get('objectId');
        let ajaxCallback = function (uri) {
            window.location.href = uri;
        };

        let request = new Ajax({
            url: url,
            data: {'city_id': city_id},
            callback: ajaxCallback
        })

        request.ajaxRequest();

        return false;
    }

    let params = {
        center: {
            lat: 62.297992,
            lon: 66.069553,
        },
        zoom: 8,
        clickCallback: clickCallback
    }

    let map = new YaMapGeography(e, placemarks, params);
    map.render();
}